import { Modal } from "@/components/elements/Modal";
import { FCC } from "@/types/common";
import { Box, Typography, Link } from "@mui/material";
import { TCheckPassportDuplicateDto } from "@/api/services/main/talent/dtos/check-passport-duplicate.dto";
import { AppRoutes } from "@/routes/config";
import { getDynamicRoute } from "@/utils/url";
import { text } from "@/theme/colors";

type TDuplicatePassportModalProps = {
  open: boolean;
  onClose: () => void;
  duplicateTalents: TCheckPassportDuplicateDto[];
  passportNumber: string;
};

export const DuplicatePassportModal: FCC<TDuplicatePassportModalProps> = ({ open, onClose, duplicateTalents, passportNumber }) => {
  const handleTalentClick = (talentId: number) => {
    const detailRoute = getDynamicRoute(AppRoutes.talentDetail, { talentId: String(talentId) });
    window.open(`${detailRoute}#passport_code_input`, "_blank");
  };

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      labelClose="閉じる"
      width={600}
      enableFooter={true}
      hiddenOkBtn={true}
      justifyBtnAction="center"
      title={
        <Box sx={{ flex: 1, textAlign: "left" }}>
          <Typography variant="head20Bold">エラー</Typography>
        </Box>
      }
    >
      <Box mb={2} sx={{ mt: 2 }}>
        <Typography variant="body1" sx={{ textAlign: "left" }}>
          パスポート番号 （{passportNumber}）が
          {duplicateTalents.map((talent) => (
            <Link
              key={talent.id}
              component="button"
              variant="body1"
              onClick={() => handleTalentClick(talent.id)}
              sx={{
                display: "inline-block",
                textDecoration: "underline",
                color: text.primary,
                cursor: "pointer",
                wordBreak: "break-word",
                maxWidth: "100%",
                "&:hover": {
                  textDecoration: "underline",
                },
                mb: 0.6,
              }}
            >
              {talent.fullName}
            </Link>
          ))}
          と重複しています。
        </Typography>
      </Box>
    </Modal>
  );
};
